export default __webpack_public_path__ + "static/media/Brow_1_C3.ff90f7da.svg";